<template>
  <el-dialog
    v-model="showMemberDialog"
    width="30%"
    align-center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    class="elv-project-setting-member-dialog"
    @close="onCloseDialog"
  >
    <template #header="{ titleId }">
      <h4 :id="titleId" class="elv-project-setting-member-dialog-header__title">
        {{ props.model === 'add' ? t('button.addMember') : t('button.editMember') }}
      </h4>
    </template>
    <el-form ref="memberFormRef" :model="memberForm" :rules="rules" label-position="top">
      <el-form-item label="Member email" prop="email">
        <el-input v-model.trim="memberForm.email" :disabled="props.model === 'edit'" placeholder="" />
      </el-form-item>
      <el-form-item label="Permission" class="elv-project-form-permission">
        <div class="elv-project-permission">
          <div v-if="projectStore?.projectEntityList.length > 1" class="elv-project-permission-same">
            <el-checkbox v-model="sameInAllEntities" :label="t('common.sameInAllEntities')" />
          </div>
          <el-scrollbar
            height="326"
            view-class="elv-project-member-permission-content"
            wrap-class="elv-project-member-permission-wrap"
          >
            <div :class="{ 'is-disabled': !sameInAllEntities }">
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.dataSourceCheckAll"
                  :label="t('report.source')"
                  :indeterminate="permissionCheckStatus.dataSourceIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('dataSource', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.dataSource.view"
                  @change="onCheckedPermissionChange('dataSource')"
                  >{{ t('common.viewListPermission', { operating: t('report.source') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.dataSource.create"
                  @change="onCheckedPermissionChange('dataSource')"
                  >{{ t('common.addNewPermission', { operating: t('report.source') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.dataSource.update"
                  @change="onCheckedPermissionChange('dataSource')"
                  >{{ t('common.editPermission', { operating: t('report.source') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.dataSource.delete"
                  @change="onCheckedPermissionChange('dataSource')"
                  >{{ t('common.deletePermission', { operating: t('report.source') }) }}</el-checkbox
                >
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.entityAccountCheckAll"
                  :label="t('common.account')"
                  :indeterminate="permissionCheckStatus.entityAccountIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('entityAccount', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.entityAccount.view"
                  @change="onCheckedPermissionChange('entityAccount')"
                  >{{ t('common.viewListPermission', { operating: t('common.account') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.entityAccount.create"
                  @change="onCheckedPermissionChange('entityAccount')"
                  >{{ t('common.addNewPermission', { operating: t('common.account') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.entityAccount.update"
                  @change="onCheckedPermissionChange('entityAccount')"
                  >{{ t('common.editPermission', { operating: t('common.account') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.entityAccount.delete"
                  @change="onCheckedPermissionChange('entityAccount')"
                  >{{ t('common.deletePermission', { operating: t('common.account') }) }}</el-checkbox
                >
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.contactCheckAll"
                  :label="t('common.contact')"
                  :indeterminate="permissionCheckStatus.contactIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('contact', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox v-model="permissionData.contact.view" @change="onCheckedPermissionChange('contact')">{{
                  t('common.viewListPermission', { operating: t('common.contact') })
                }}</el-checkbox>
                <el-checkbox v-model="permissionData.contact.create" @change="onCheckedPermissionChange('contact')">{{
                  t('common.addNewPermission', { operating: t('common.contact') })
                }}</el-checkbox>
                <el-checkbox v-model="permissionData.contact.update" @change="onCheckedPermissionChange('contact')">{{
                  t('common.editPermission', { operating: t('common.contact') })
                }}</el-checkbox>
                <el-checkbox v-model="permissionData.contact.delete" @change="onCheckedPermissionChange('contact')">{{
                  t('common.deletePermission', { operating: t('common.contact') })
                }}</el-checkbox>
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.reportCheckAll"
                  :label="t('common.report')"
                  :indeterminate="permissionCheckStatus.reportIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('report', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox v-model="permissionData.report.view" @change="onCheckedPermissionChange('report')">{{
                  t('common.viewListPermission', { operating: t('common.report') })
                }}</el-checkbox>
                <el-checkbox v-model="permissionData.report.generate" @change="onCheckedPermissionChange('report')">{{
                  t('common.generatePermission', { operating: t('common.report') })
                }}</el-checkbox>
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.transactionCheckAll"
                  label="Transaction"
                  :indeterminate="permissionCheckStatus.transactionIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('transaction', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.transaction.viewList"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.viewListPermission', { operating: t('report.transaction') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.transaction.viewDetail"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.viewDetailPermission', { operating: t('report.transaction') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.transaction.update"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.editPermission', { operating: t('report.transaction') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.transaction.export"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.exportPermission', { operating: t('report.transaction') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.transaction.review"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.reviewPermission', { operating: t('report.transaction') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.transaction.erp"
                  @change="onCheckedPermissionChange('transaction')"
                  >{{ t('common.syncToErp', { operating: t('report.transaction') }) }}</el-checkbox
                >
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.generalLedgerCheckAll"
                  :label="t('project.nav.generalLedger')"
                  :indeterminate="permissionCheckStatus.generalLedgerIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('generalLedger', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.generalLedger.view"
                  @change="onCheckedPermissionChange('generalLedger')"
                  >{{ t('common.viewListPermission', { operating: t('project.nav.generalLedger') }) }}</el-checkbox
                >
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.resolutionCenterCheckAll"
                  :label="t('report.resolutionCenter')"
                  :indeterminate="permissionCheckStatus.resolutionCenterIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('resolutionCenter', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.resolutionCenter.view"
                  @change="onCheckedPermissionChange('resolutionCenter')"
                  >{{ t('common.viewListPermission', { operating: t('report.resolutionCenter') }) }}</el-checkbox
                >
              </div>
              <div class="elv-project-permission-level-1">
                <el-checkbox
                  v-model="permissionCheckStatus.configRuleCheckAll"
                  :label="t('common.rule')"
                  :indeterminate="permissionCheckStatus.configRuleIsIndeterminate"
                  @change="onCheckPermissionClassifyAllChange('configRule', $event)"
                />
              </div>
              <div class="elv-project-permission-level-2">
                <el-checkbox
                  v-model="permissionData.configRule.view"
                  @change="onCheckedPermissionChange('configRule')"
                  >{{ t('common.viewListPermission', { operating: t('common.rule') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.configRule.create"
                  @change="onCheckedPermissionChange('configRule')"
                  >{{ t('common.addNewPermission', { operating: t('common.rule') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.configRule.update"
                  @change="onCheckedPermissionChange('configRule')"
                  >{{ t('common.editPermission', { operating: t('common.rule') }) }}</el-checkbox
                >
                <el-checkbox
                  v-model="permissionData.configRule.delete"
                  @change="onCheckedPermissionChange('configRule')"
                  >{{ t('common.deletePermission', { operating: t('common.rule') }) }}</el-checkbox
                >
              </div>
            </div>
          </el-scrollbar>
          <Permission
            v-if="!sameInAllEntities"
            ref="permissionListRef"
            :model="props.model"
            :current-permissions="currentMemberPermissionData"
          />
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <elv-button
        width="95"
        height="44"
        round
        :loading="submitLoading"
        :disabled="memberForm.email === ''"
        @click="onClickConnect"
        >{{ props.model === 'add' ? t('button.add') : t('button.save') }}</elv-button
      >
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import ProjectApi from '@/api/ProjectApi'
import Permission from './Permission.vue'
import { useProjectStore } from '@/stores/modules/project'
import type { FormInstance, FormRules } from 'element-plus'
import { forEach, every, isEmpty, partial, isEqual, throttle, upperFirst } from 'lodash-es'
// import { useReportStore } from '@/stores/modules/reports/index.js'

const props = defineProps({
  model: {
    type: String,
    default: 'add'
  },
  currentData: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const { t } = useI18n()
// const reportStore = useReportStore()
const projectStore = useProjectStore()

const memberForm = reactive({
  email: ''
})

const route = useRoute()
const submitLoading = ref(false)
const showMemberDialog = ref(false)
const sameInAllEntities = ref(false)
const memberFormRef = ref<FormInstance>()
const permissionListRef = ref()

const rules = reactive<FormRules>({
  email: {
    required: true,
    trigger: 'blur',
    message: 'Member Email is required'
  }
})

const permissionCheckStatus: any = ref({
  dataSourceCheckAll: true,
  contactCheckAll: true,
  reportCheckAll: true,
  entityAccountCheckAll: true,
  transactionCheckAll: true,
  configRuleCheckAll: true,
  generalLedgerCheckAll: true,
  resolutionCenterCheckAll: true,
  dataSourceIsIndeterminate: false,
  contactIsIndeterminate: false,
  reportIsIndeterminate: false,
  entityAccountIsIndeterminate: false,
  transactionIsIndeterminate: false,
  configRuleIsIndeterminate: false,
  generalLedgerIsIndeterminate: false,
  resolutionCenterIsIndeterminate: false
})

const permissionData: any = ref({
  dataSource: {
    view: true,
    create: true,
    update: true,
    delete: true
  },
  contact: {
    view: true,
    create: true,
    update: true,
    delete: true
  },
  transaction: {
    viewList: true,
    viewDetail: true,
    update: true,
    export: true,
    review: true,
    erp: true
  },
  report: {
    view: true,
    generate: true
  },
  entityAccount: {
    view: true,
    create: true,
    update: true,
    delete: true
  },
  configRule: {
    view: true,
    create: true,
    update: true,
    delete: true
  },
  generalLedger: {
    view: true
  },
  resolutionCenter: {
    view: true
  }
})

const projectId = computed(() => {
  return Number(route.params?.projectId)
})

const currentMemberPermissionData = computed(() => {
  return props.currentData?.entityList?.map((item: any) => {
    return { entityId: item.entityId, permission: projectStore.entityPermission(item) }
  })
})

// 切换删除弹窗展示
const onCheckMemberDialog = () => {
  showMemberDialog.value = !showMemberDialog.value
}

const onCloseDialog = () => {
  memberForm.email = ''
  memberFormRef.value?.resetFields()
}

const onCheckPermissionClassifyAllChange = (type: string, val: any) => {
  if (val) {
    permissionCheckStatus.value[`${type}CheckAll`] = true
    Object.keys(permissionData.value[type])
    permissionData.value[type] = Object.keys(permissionData.value[type]).reduce((obj: any, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = true
      return obj
    }, {})
  } else {
    permissionCheckStatus.value[`${type}CheckAll`] = false
    permissionData.value[type] = Object.keys(permissionData.value[type]).reduce((obj: any, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = false
      return obj
    }, {})
  }
  permissionCheckStatus.value[`${type}IsIndeterminate`] = false
}

const onCheckedPermissionChange = (type: string) => {
  permissionCheckStatus.value[`${type}CheckAll`] = Object.values(permissionData.value[type]).every(
    (val) => val === true
  )
  permissionCheckStatus.value[`${type}IsIndeterminate`] =
    Object.values(permissionData.value[type]).some((val) => val === true) &&
    !permissionCheckStatus.value[`${type}CheckAll`]
  permissionCheckStatus.value.checkAll = Object.values(permissionData.value).every((obj: any) => {
    return Object.values(obj).every((val) => val === true)
  })
}

const onClickConnect = async () => {
  if (!memberFormRef.value) return
  await memberFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        submitLoading.value = true
        const formattedPermissions: any = {}
        forEach(permissionData.value, (value: any, key: any) => {
          forEach(value, (v: any, k: any) => {
            const formattedKey = `${key}${upperFirst(k)}`
            formattedPermissions[formattedKey] = v
          })
        })
        const params: any = {
          email: memberForm.email
        }
        if (sameInAllEntities.value) {
          params.permissions = projectStore.projectEntityList.map((entity) => {
            return {
              entityId: entity.entityId,
              permission: formattedPermissions
            }
          })
        } else {
          params.permissions = projectStore.projectEntityList.map((item: any, i: number) => {
            const formattedPermission: any = {}
            forEach(permissionListRef.value?.permissionData[i], (value: any, key: any) => {
              forEach(value, (v: any, k: any) => {
                const formattedKey = `${key}${upperFirst(k)}`
                formattedPermission[formattedKey] = v
              })
            })
            return {
              permission: formattedPermission,
              entityId: item.entityId
            }
          })
        }
        if (props.model === 'edit') {
          await ProjectApi.editProjectMember(projectId.value, props.currentData?.userId, params)
        } else {
          await ProjectApi.addProjectMember(projectId.value, params)
          projectStore.fetchProjectDetail(projectId.value)
        }
        submitLoading.value = false
        memberFormRef.value?.resetFields()
        projectStore.fetchProjectMemberList(projectId.value)
        permissionData.value = {
          dataSource: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          contact: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          transaction: {
            viewList: true,
            viewDetail: true,
            update: true,
            export: true,
            review: true,
            erp: true
          },
          report: {
            view: true,
            generate: true
          },
          entityAccount: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          configRule: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          generalLedger: {
            view: true
          },
          resolutionCenter: {
            view: true
          }
        }
        permissionCheckStatus.value = {
          dataSourceCheckAll: true,
          contactCheckAll: true,
          reportCheckAll: true,
          entityAccountCheckAll: true,
          transactionCheckAll: true,
          configRuleCheckAll: true,
          generalLedgerCheckAll: true,
          resolutionCenterCheckAll: true,
          dataSourceIsIndeterminate: false,
          contactIsIndeterminate: false,
          reportIsIndeterminate: false,
          entityAccountIsIndeterminate: false,
          transactionIsIndeterminate: false,
          configRuleIsIndeterminate: false,
          generalLedgerIsIndeterminate: false,
          resolutionCenterIsIndeterminate: false
        }
        showMemberDialog.value = false
        ElMessage.success(t('message.saveSuccess'))
      } catch (error: any) {
        submitLoading.value = false
        ElMessage.error(error?.message)
        console.log(error)
      }
    }
  })
}

const leftScroll = () => {
  const top = document.getElementsByClassName('elv-project-member-permission-wrap')[0]?.scrollTop
  if (!sameInAllEntities.value) {
    document.getElementsByClassName('elv-project-permission-wrap')[0].scrollTop = top
  }
}

defineExpose({ onCheckMemberDialog })

watch([() => props.currentData, () => showMemberDialog.value], () => {
  if (showMemberDialog.value) {
    nextTick(() => {
      if (!isEmpty(props.currentData) && props.model === 'edit') {
        memberForm.email = props.currentData.email
        const permissionDataArr = currentMemberPermissionData.value.map((item: any) => item.permission)
        // 用lodash判断permissionDataArr数组中每个对象是否相同
        const isSame = every(permissionDataArr, partial(isEqual, permissionDataArr[0]))
        sameInAllEntities.value =
          isSame && currentMemberPermissionData.value.length === projectStore.projectEntityList.length
        if (sameInAllEntities.value) {
          Object.keys(currentMemberPermissionData.value[0].permission).forEach((item) => {
            permissionCheckStatus.value[`${item}CheckAll`] = Object.values(
              currentMemberPermissionData.value[0].permission[item]
            ).every((val) => val === true)
            permissionCheckStatus.value[`${item}IsIndeterminate`] =
              Object.values(currentMemberPermissionData.value[0].permission[item]).some((val) => val === true) &&
              !permissionCheckStatus.value[`${item}CheckAll`]
          })
          // eslint-disable-next-line prefer-destructuring
          permissionData.value = currentMemberPermissionData.value[0].permission
        }
      } else if (isEmpty(props.currentData) && props.model === 'add') {
        memberForm.email = ''
        sameInAllEntities.value = true
        memberFormRef.value?.resetFields()
        permissionData.value = {
          dataSource: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          contact: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          transaction: {
            viewList: true,
            viewDetail: true,
            update: true,
            export: true,
            review: true,
            erp: true
          },
          report: {
            view: true,
            generate: true
          },
          entityAccount: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          configRule: {
            view: true,
            create: true,
            update: true,
            delete: true
          },
          generalLedger: {
            view: true
          },
          resolutionCenter: {
            view: true
          }
        }
        permissionCheckStatus.value = {
          dataSourceCheckAll: true,
          contactCheckAll: true,
          reportCheckAll: true,
          entityAccountCheckAll: true,
          transactionCheckAll: true,
          configRuleCheckAll: true,
          generalLedgerCheckAll: true,
          resolutionCenterCheckAll: true,
          dataSourceIsIndeterminate: false,
          contactIsIndeterminate: false,
          reportIsIndeterminate: false,
          entityAccountIsIndeterminate: false,
          transactionIsIndeterminate: false,
          configRuleIsIndeterminate: false,
          generalLedgerIsIndeterminate: false,
          resolutionCenterIsIndeterminate: false
        }
      }
    })
  }
})

watchEffect(() => {})

// onMounted(() => {})

watch(
  () => showMemberDialog.value,
  () => {
    if (showMemberDialog.value) {
      nextTick(() => {
        document
          .getElementsByClassName('elv-project-member-permission-wrap')[0]
          ?.addEventListener('scroll', throttle(leftScroll))
      })
    } else {
      document
        .getElementsByClassName('elv-project-member-permission-wrap')[0]
        ?.removeEventListener('scroll', leftScroll)
    }
  }
)

onBeforeUnmount(() => {
  document.getElementsByClassName('elv-project-member-permission-wrap')[0]?.removeEventListener('scroll', leftScroll)
})
</script>

<style lang="scss">
.elv-project-setting-member-dialog {
  width: 620px;
  min-height: 565px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.3);
  border-radius: 6px;

  .el-dialog__header {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    height: 54px;
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    margin: 0;
    padding: 0;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-start;
    color: #0e0f11;
    padding-left: 24px;
    border-bottom: 1px solid #edf0f3;

    .elv-project-setting-member-dialog-header__title {
      font-family: 'Plus Jakarta Sans';
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #0e0f11;
      margin: 0;
    }
  }

  .el-dialog__body {
    padding: 18px 24px 44px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    p {
      margin: 0;
    }

    .el-input {
      width: 572px;
      height: 44px;
      border-radius: 4px;

      &.is-disabled {
        background: #f9fafb;
      }
    }

    .el-input__inner {
      font-family: 'Plus Jakarta Sans';
      font-weight: 400;
      font-size: 14px;
      color: #0e0f11;
    }

    .el-input__wrapper {
      border-radius: 4px;
      border: 1px solid #dde1e6;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
      padding: 1px 12px;
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    .el-input:not(.is-disabled) .el-input__wrapper {
      &:hover {
        border: 1px solid #7596eb !important;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15) !important;
      }

      &.is_focus {
        border: 1px solid #7596eb !important;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15) !important;
      }
    }

    .el-form-item {
      margin-bottom: 16px;

      &:last-of-type {
        margin-bottom: 0px;
      }

      &.is-error {
        .el-input__wrapper {
          background: #faeee6;
          border: 1px solid #7e4a15;
        }

        .el-input__inner {
          color: #7e4a15;
        }

        .el-form-item__error {
          font-family: 'Plus Jakarta Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
          color: #7e4a15;
        }
      }

      .el-form-item__label {
        font-family: 'Plus Jakarta Sans';
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        text-transform: capitalize;
        color: #636b75;
      }

      &.elv-project-form-permission {
        .el-form-item__label {
          color: #0e0f11;
          font-weight: 700;
          font-size: 15px;
          line-height: 18px;
          margin-bottom: 16px;
        }
      }
    }

    .el-select {
      .el-input.is-focus:not(.el-select--disabled) .el-input__wrapper {
        border: 1px solid #7596eb !important;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15) !important;
      }
    }

    .el-input__wrapper.is-focus {
      border: 1px solid #7596eb !important;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15) !important;
    }

    .elv-source-dialog-exchange-prefix {
      width: 20px;
      height: 20px;
      display: block;
    }
  }

  .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;

    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      width: 113px;
      background: #1753eb;
      border-radius: 22px;
      font-family: 'Plus Jakarta Sans';
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      color: #fff;
      border: 0px;
    }

    .elv-project-setting-member-dialog-footer__cancel {
      background: #edf0f3;
      color: #636b75;
    }

    .elv-project-setting-member-dialog-footer__delete {
      margin-left: 20px;
    }
  }
}

.elv-project-permission {
  width: 100%;

  .el-scrollbar__view.elv-project-member-permission-content {
    width: 572px !important;
    position: relative;

    .is-disabled {
      .el-checkbox .el-checkbox__inner {
        display: none;
      }
    }
  }

  .elv-project-permission-same {
    .el-checkbox {
      height: 18px;
      padding: 0px;
      margin-bottom: 8px;
      flex-direction: row;
      justify-content: flex-start;

      .el-checkbox__input {
        padding-left: 2px;
      }

      .el-checkbox__label {
        color: #000;
        font-size: 12px;
        line-height: 14px;
      }
    }
  }

  .el-checkbox {
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: #1e2024;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    flex-direction: row-reverse;
    padding: 8px;
    height: 34px;

    &.is-checked {
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #1e2024;
      }
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #1753eb;
      background-color: #1753eb;

      &:after {
        left: 3.5px;
      }
    }

    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #1753eb;
      background-color: #fff;

      &::before {
        height: 2.5px;
        top: 4.5px;
        background-color: #1753eb;
      }
    }

    .el-checkbox__inner {
      width: 13.5px;
      height: 13.5px;
      box-sizing: border-box;

      border: 1.5px solid #d0d4d9;
      background: #fff;
    }

    .el-checkbox__input {
      width: 18px;
      height: 18px;
      display: flex;
      justify-items: center;
      align-items: center;
    }

    .el-checkbox__label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 0;
      font-family: 'Plus Jakarta Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #0e0f11;

      img {
        width: 18px;
        height: 18px;
        display: block;
      }

      span {
        font-weight: 500;
        margin-left: 8px;
      }
    }
  }

  .elv-project-permission-level-1 {
    background: #f9fafb;
    border-bottom: 1px solid #edf0f3;

    &:first-child {
      border-top: 1px solid #edf0f3;
    }

    .el-checkbox__label {
      font-weight: 600;
    }
  }

  .elv-project-permission-level-2 {
    .el-checkbox {
      border-bottom: 1px solid #edf0f3;
    }

    .el-checkbox__label {
      margin-left: 40px;
    }
  }
}

.elv-source-dialog-popper {
  &.el-popper {
    transform: translateY(-11.5px);
  }

  .el-select-dropdown__list {
    padding: 0;
  }

  .el-select-dropdown__item {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    font-family: 'Plus Jakarta Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #0e0f11;

    &.hover {
      background: #f9fafb;
    }

    .elv-source-dialog-exchange-option {
      display: flex;
      align-items: center;

      img {
        display: block;
        width: 20px;
        height: 20px;
        filter: drop-shadow(0px 1px 3px rgba(33, 27, 78, 0.15));
        margin-right: 10px;
      }

      p {
        font-family: 'Plus Jakarta Sans';
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #0e0f11;
        display: flex;
        align-items: center;
      }

      span {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 4px;
        width: 32px;
        height: 18px;
        border: 1px solid #dde1e6;
        border-radius: 3px;
        margin-left: 10px;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        color: #d0d4d9;
      }
    }
  }
}
</style>
